import { Heart } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function GDPRPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="gdpr-page">
      {/* Header */}
      <header className="bg-white border-b border-border sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 text-primary">
              <Heart weight="fill" className="w-7 h-7" />
              <span className="text-xl font-bold font-[Manrope]">MEDICULDIGITAL</span>
            </Link>
            <Link 
              to="/register" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              ← Înapoi la înregistrare
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold font-[Manrope] text-foreground mb-8">
            Protecția datelor cu caracter personal – GDPR
          </h1>

          <h2 className="text-xl font-semibold mt-8 mb-4">I. Introducere</h2>
          <p>
            În calitatea sa de operator de date cu caracter personal, NETWORK CONSULTANCY SERVICES LLC – NCS LLC, respectă dispozițiile legale privitoare la protecția datelor cu caracter personal și pune în aplicare măsuri tehnice și organizatorice de protejare a tuturor operațiunilor care privesc în mod direct sau indirect datele cu caracter personal și care previn prelucrările neautorizate sau ilegale, precum și pierderile sau distrugerile accidentale sau ilegale.
          </p>
          <p>
            NETWORK CONSULTANCY SERVICES LLC – NCS LLC, este o companie înregistrată în Statele Unite ale Americii, Delaware 1995816192, cu sediul în 16192 Coastal Highway, Lewes, număr de înregistrare 5433202.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">II. Legislație – Documente de referință</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Regulamentul (UE) nr. 679 din 27 aprilie 2016 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal (GDPR);</li>
            <li>Legea nr. 190 din 18 iulie 2018 privind măsuri de punere în aplicare a Regulamentului (UE) 2016/679;</li>
            <li>Legea nr. 102 din 3 mai 2005 privind înființarea Autorității Naționale de Supraveghere a Prelucrării Datelor cu Caracter Personal;</li>
            <li>Legea nr. 129 din 15 iunie 2018 pentru modificarea și completarea Legii nr. 102/2005.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">III. Terminologie – definiții</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Date cu caracter personal:</strong> orice informaţii privind o persoană fizică identificată sau identificabilă ("persoana vizată");</li>
            <li><strong>Categorii speciale de date:</strong> date care dezvăluie originea rasială sau etnică, opinii politice, convingeri religioase sau filosofice, apartenența sindicală, date genetice, biometrice, date privind sănătatea;</li>
            <li><strong>Operator de date:</strong> persoană fizică sau juridică care determină scopurile și mijloacele de prelucrare a datelor;</li>
            <li><strong>Persoana vizată:</strong> orice persoană vie care face obiectul datelor cu caracter personal;</li>
            <li><strong>Prelucrare:</strong> orice operațiune care vizează date personale (colectare, înregistrare, stocare, modificare, ștergere etc.);</li>
            <li><strong>Consimţământ:</strong> orice manifestare de voinţă liberă, specifică, informată şi lipsită de ambiguitate;</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">IV. Tipuri de date prelucrate</h2>
          <p>NCS LLC prelucrează numai datele personale strict necesare, având un temei juridic valid:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Relații publice:</strong> nume, prenume, semnătură, detalii de contact;</li>
            <li><strong>Economic/financiar:</strong> date privind salarizarea, efectuare de plăți;</li>
            <li><strong>Organizare evenimente:</strong> nume, prenume, funcție, profesie, denumire angajator;</li>
            <li><strong>Contracte:</strong> nume, prenume, funcție, denumire angajator/furnizor, detalii contact;</li>
            <li><strong>Sănătate:</strong> date medicale necesare pentru furnizarea serviciilor.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">V. Sursa datelor</h2>
          <p>NCS LLC colectează date personale direct de la persoanele vizate, de la terți sau din documente primite în executarea funcției.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">VI. Categorii de destinatari</h2>
          <p>Datele sunt destinate utilizării de către NCS LLC și pot fi comunicate către: persoanele vizate, angajați, parteneri contractuali, alte instituții/autorități, instanțe de judecată și auditori.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">VII. Stocarea datelor</h2>
          <p>Datele sunt stocate pe perioada necesară obligațiilor legale ale NCS LLC, după care sunt arhivate potrivit Legii Arhivelor Naționale nr. 16/1996.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">VIII. Drepturile persoanelor vizate</h2>
          <p>Orice solicitare trebuie formulată în scris, datată și semnată și transmisă la adresa de email: <strong>ncsllcia@gmail.com</strong></p>
          
          <p className="mt-4">Persoanele vizate au dreptul de a depune o plângere la Autoritatea Națională de Supraveghere:</p>
          <ul className="list-none pl-6 space-y-1">
            <li><strong>Sediul:</strong> B-dul G-ral Gheorghe Magheru 28-30, sector 1, București</li>
            <li><strong>Telefon:</strong> 031.805.92.11</li>
            <li><strong>Website:</strong> www.dataprotection.ro</li>
            <li><strong>E-mail:</strong> anspdcp@dataprotection.ro</li>
          </ul>

          <hr className="my-8" />
          <p className="text-sm text-muted-foreground">© 2026 NCS LLC Legal. All rights reserved.</p>
        </article>
      </main>
    </div>
  );
}
